module.exports = __webpack_public_path__ + "img/gallery.65a44b31.svg";